import { User } from '../interfaces/user.interface';
import { AccountService } from './account.service';
import { Inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { TokenStorageService } from './helpers/token.service';
import { environment } from '../../../environments/environment';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class SocketService {
  subscribersCounter: Record<string, number> = {};
  eventObservables$: Record<string, Observable<any>> = {};
  currentUser: User;

  EVENTS = {
    connect: 'connect',
    reconnect: 'reconnect',
    startTraining: 'started-session',
    completeTraining: 'completed-session',
    pauseTraining: 'paused-session',
    resumeTraining: 'resumed-session',
    startSession: 'started-session-scenario',
    completeSession: 'completed-session-scenario',
    startSessionItem: 'started-session-scenario-item',
    completeSessionItem: 'completeSessionItem',
    answerSessionItem: 'answered-session-scenario-item',
    addToTeam: 'set-session-team-for-participant',
    setTeamLeader: 'set-team-lead',
    addMessage: 'created-session-chat-message',
    editMessage: 'updated-session-chat-message',
    deleteMessage: 'deleted-session-chat-message',
    addIncidentComment: 'created-session-incident-comment',
    editIncidentComment: 'updated-session-incident-comment',
    deleteIncidentComment: 'deleted-session-incident-comment',
    approveParticipation: 'approved-participation',
    logoutUser: 'logout',
    userRegistered: 'registered-participant',
    approveUser: 'approved-participant',
    createSessionItem: 'created-session-scenario-item',
    addedUsersToTraining: 'assigned-participant-to-session',
    updateSessionItem: 'updated-session-scenario-item',
    trainingOverviewGenerated: 'generated-training-overview-for-instructor',
    assessmentOverviewGenerated: 'generated-assessment-overview-for-instructor',
    generatedCompanyUsageSummaryReportEvent: 'generated-company-usage-summary-report',
    sentParticipantTrainingOverview: 'sent-training-overview-for-participant',
    resumedSessionScenarioItem: 'resumed-session-scenario-item',
    pausedSessionScenarioItem: 'paused-session-scenario-item',
    deletedSessionScenarioItem: 'deleted-session-scenario-item'
  };
  prefixUserRoom = 'user_';
  private eventData$ = new Subject<any>();
  private connectionStatus$ = new Subject<any>();
  subscriptions = [];
  client: any;
  pusher: any;
  channel: any;

  constructor(public accountService: AccountService,
              private tokenService: TokenStorageService,
              @Inject(DOCUMENT) private document: any) {
    this.initSocket();
  }

  initSocket() {
    this.currentUser = this.accountService.getAccount();
    if (this.currentUser) {
      // @ts-ignore
      const PusherJS = require('pusher-js');
      const config = {
        cluster: '',
        wsHost: this.document.location.hostname,
        wsPort: this.document.location.port,
        forceTLS: this.document.location.protocol === 'https:',
        encrypted: true,
        disableStats: true,
        channelAuthorization: {
          endpoint: '/broadcasting/auth',
          headers: {
            Authorization: `Bearer ${this.tokenService.getToken()}`,
            Accept: 'application/json',
          },
        },
      };
      this.client = new PusherJS(environment.ws.key, config);
      this.client.connection.bind('connected',  () => {
        console.log('Connected');
        this.setConnectionStatus('Connected');
      });
      this.subscribe();
    }
  }

  subscribe() {
    if (this.currentUser) {
      this.channel = this.client.subscribe(`private-user.${this.currentUser.id}`);
      this.subscribeForAll();
    }
  }

  unSubscribe(userId) {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.client.unsubscribe(`private-user.${userId}`);

  }

  setEventData(data) {
    this.eventData$.next(data);
  }

  getEventData() {
    return this.eventData$.asObservable();
  }

  getConnectionStatus() {
    return this.connectionStatus$.asObservable();
  }

  setConnectionStatus(data) {
    this.connectionStatus$.next(data);
  }

  subscribeForAll() {
    Object.values(this.EVENTS).forEach((event) => {
      this.subscriptions.push(
        this.channel.bind(event, (res) => {
          const data = {
            event,
            data: res
          };
          console.log(data);
          this.setEventData(data);
        })
      );


    });
  }
}
